import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

// Cómo se ve cada motivo. La clave rechazada va aparte: es lo más probable, no seguro.
export const TIPOS_REVISION = {
    CLAVE_RECHAZADA: { etiqueta: 'Clave posiblemente incorrecta', color: '#991b1b', fondo: '#fee2e2' },
    NO_ENTRA: { etiqueta: 'No pudo entrar a Mi ANSES', color: '#9a3412', fondo: '#ffedd5' },
    SIN_CLAVE: { etiqueta: 'Sin clave guardada', color: '#854d0e', fondo: '#fef9c3' },
    ATRASADO: { etiqueta: 'Atrasado', color: '#334155', fondo: '#f1f5f9' },
    // El expediente es de otra persona (apoderado): el robot no lo puede ver con la clave del cliente.
    APODERADO: { etiqueta: 'Expediente de otra persona (apoderado)', color: '#5b21b6', fondo: '#ede9fe' },
};

const formatoFecha = (iso) => {
    if (!iso) return '—';
    const d = new Date(iso);
    return Number.isNaN(d.getTime()) ? '—' : d.toLocaleDateString('es-AR');
};

/**
 * "Revisión manual": los clientes que el robot de ANSES no está pudiendo revisar solo (no pudo
 * entrar, la clave parece incorrecta, no hay clave o está atrasado). No avisa a nadie: se ve acá.
 * Conectar abre el cliente en Seguimiento de Expedientes, donde está el login manual.
 */
export default function RevisionManualSeguimiento({ items = [] }) {
    const navigate = useNavigate();
    const [abierto, setAbierto] = useState(false);
    if (!items.length) return null;

    const conteo = items.reduce((acc, i) => ({ ...acc, [i.tipo]: (acc[i.tipo] || 0) + 1 }), {});

    return (
        <div className="card mb-3" style={{ border: '1px solid #fdba74', borderRadius: 12 }}>
            <button
                type="button" className="btn text-start d-flex flex-wrap align-items-center gap-2 px-3 py-2"
                onClick={() => setAbierto((v) => !v)} aria-expanded={abierto}
                style={{ background: '#fff7ed', borderRadius: 12 }}
            >
                <i className={`bi ${abierto ? 'bi-chevron-up' : 'bi-chevron-down'}`} />
                <span style={{ fontWeight: 700, color: '#9a3412' }}>
                    <i className="bi bi-person-gear me-1" />Revisión manual del seguimiento automático ({items.length})
                </span>
                {Object.entries(TIPOS_REVISION).filter(([t]) => conteo[t]).map(([t, v]) => (
                    <span key={t} style={{ background: v.fondo, color: v.color, borderRadius: 12, padding: '1px 10px', fontSize: '0.78rem', fontWeight: 600 }}>
                        {conteo[t]} · {v.etiqueta}
                    </span>
                ))}
            </button>
            {abierto && (
                <div className="card-body py-2" style={{ maxHeight: 360, overflowY: 'auto' }}>
                    <table className="table table-sm mb-0" style={{ fontSize: '0.82rem' }}>
                        <thead>
                            <tr style={{ color: '#4b5563' }}>
                                <th>Cliente</th><th>Motivo</th><th>Última revisión</th><th />
                            </tr>
                        </thead>
                        <tbody>
                            {items.map((i) => {
                                const tipo = TIPOS_REVISION[i.tipo] || TIPOS_REVISION.ATRASADO;
                                return (
                                    <tr key={i.cuil}>
                                        <td>
                                            <div style={{ fontWeight: 600 }}>{i.cliente || 'Sin nombre'}</div>
                                            <div style={{ fontSize: '0.74rem', color: '#4b5563' }}>{i.cuil}</div>
                                        </td>
                                        <td>
                                            <span style={{ background: tipo.fondo, color: tipo.color, borderRadius: 12, padding: '1px 8px', fontSize: '0.74rem', fontWeight: 600 }}>
                                                {tipo.etiqueta}
                                            </span>
                                            <div style={{ fontSize: '0.76rem', color: '#374151' }} title={i.detalle || ''}>{i.motivo}</div>
                                        </td>
                                        <td style={{ whiteSpace: 'nowrap' }}>{formatoFecha(i.ultimaRevision)}</td>
                                        <td className="text-end">
                                            <button type="button" className="btn btn-sm btn-outline-primary py-0"
                                                onClick={() => navigate(`/herramientas/seguimiento-expedientes/cliente/${encodeURIComponent(i.cuilRobot || i.cuil)}`)}>
                                                {i.tipo === 'ATRASADO' ? 'Ver' : 'Conectar a mano'}
                                            </button>
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
}
